.root {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.label {
  font-family: var(--sans);
  font-size: 12.5px;
  font-weight: 600;
  color: var(--ink-3);
}

.controls {
  display: flex;
  gap: 8px;
  align-items: center;
}

.colorInput {
  width: 44px;
  height: 38px;
  padding: 0;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
}

.colorInput::-webkit-color-swatch-wrapper {
  padding: 4px;
}

.colorInput::-webkit-color-swatch {
  border: 0;
  border-radius: 4px;
}

.colorInput:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.hexInput {
  font-family: var(--mono);
  font-size: 13px;
  padding: 8px 10px;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  background: var(--surface);
  color: var(--ink);
  width: 110px;
  letter-spacing: 0.6px;
  text-transform: lowercase;
}

.hexInput:focus {
  outline: none;
  border-color: var(--role-accent);
}

.hexInputInvalid {
  border-color: var(--red);
  background: #fff5f5;
}

.hexInput:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.hint {
  font-size: 11.5px;
  color: var(--mute);
}

.warn {
  font-size: 11.5px;
  color: var(--red);
  font-weight: 600;
}
